/**
* 公司组织结构节点
*/
const oRGStructNode = {
  
addORGStructNode: "/api/addORGStructNode",//创建
modifyORGStructNode: "/api/modifyORGStructNode",//修改
deleteORGStructNode: "/api/deleteORGStructNode",//删除
getORGStructNodes: "/api/getORGStructNodes",//查询
getMountedMeasures: "/api/getMountedMeasures",//查询挂接测量点
getMountedRoles: "/api/getMountedRoles",//查询挂接角色
}

export default oRGStructNode